export default __webpack_public_path__ + "static/media/mathboardGame.52891458.png";